"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExternalUrl = exports.useLink = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var Link_style_1 = __importDefault(require("./Link.style"));
function useLink(_a) {
    var disabled = _a.disabled, fullWidth = _a.fullWidth, onNavigate = _a.onNavigate, openInNewTab = _a.openInNewTab, url = _a.url;
    var push = (0, react_router_dom_1.useHistory)().push;
    var classes = (0, Link_style_1.default)();
    var rootClassName = (0, classnames_1.default)(classes.root, fullWidth && classes.fullWidth, disabled && classes.disabled);
    var isExternalLink = isExternalUrl(url);
    var target = (openInNewTab !== null && openInNewTab !== void 0 ? openInNewTab : isExternalLink) ? '_blank' : '_self';
    var navigate = (0, react_1.useCallback)(function (event) {
        event.preventDefault();
        isExternalUrl(url) ? window.open(url, target) : push(url);
    }, [url, target, push]);
    var handleClick = (0, react_1.useCallback)(function (event) {
        var isModifiedEvent = !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
        if (event.button === 0 && // Ignore everything but left clicks
            !isModifiedEvent // Ignore clicks with modifier keys
        ) {
            onNavigate === null || onNavigate === void 0 ? void 0 : onNavigate(event);
            // Let browser handle "target=_blank" etc.
            var handleNavigation = !target || target === '_self';
            handleNavigation && navigate(event);
        }
    }, [navigate, onNavigate, target]);
    var handleKeyDown = (0, react_1.useCallback)(function (event) {
        if (event.key === 'Enter') {
            onNavigate === null || onNavigate === void 0 ? void 0 : onNavigate(event);
            navigate(event);
        }
    }, [navigate, onNavigate]);
    return { handleClick: handleClick, handleKeyDown: handleKeyDown, rootClassName: rootClassName, target: target };
}
exports.useLink = useLink;
function isExternalUrl(url) {
    return url.startsWith('https://') || url.startsWith('http://') || url.startsWith('mailto:');
}
exports.isExternalUrl = isExternalUrl;
